import styled from 'styled-components';
import { Button } from 'antd';

export const CardContainer = styled.div`
  background: #fff;
  margin-bottom: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);

  .product-title-row {
    padding: 0;
  }

  .producer-info {
    flex-direction: row;
    gap: 8px;
  }

  .price-row {
    border: none;
  }

  .button-row {
    justify-content: space-between;
  }
`;

export const Row = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
  padding: 8px;
  gap: 8px;
  flex-flow: wrap;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Col = styled.div<{ flex?: string }>`
  display: flex;
  flex-direction: column;
`;

export const ProductImage = styled.img`
  width: 56px;
  height: 56px;
  border-radius: 4px;
  object-fit: cover;
  border-right: 1px solid #f0f0f0;
`;

export const ProductName = styled.h3`
  font-size: 14px;
  font-weight: 400;
  color: #262626;
  margin: 0 0 4px 0;
  line-height: 1.2;
`;

export const ConceptName = styled.p`
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  color: #262626;
  margin: 0 0 4px 0;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Producer = styled.span`
  font-size: 10px;
  color: #f78e1e;
  font-weight: 700;
`;

export const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
  font-size: 0.875rem;
  color: #595959;
`;

export const InfoLabel = styled.span`
  font-weight: 400;
  color: #8c8c8c;
  font-size: 10px;
  margin-bottom: 2px;

  white-space: nowrap;
`;

export const InfoValue = styled.span<{ noWrap?: boolean }>`
  color: #262626;
  font-size: 12px;
  font-weight: 500;
  white-space: ${(props) => (props.noWrap ? 'nowrap' : 'normal')};
`;

export const ShowMoreButton = styled(Button)`
  background: transparent;
  border: none;
  color: #ff8200;
  height: 20px;
  font-size: 10px;
  font-weight: 400;
  box-shadow: none;
  display: flex;
  align-items: center;

  svg {
    color: #ff8200;
    font-size: 12px;
    vertical-align: middle;
  }

  &:hover,
  &:focus {
    background: transparent;
    color: #ff8200 !important;
    opacity: 0.8;
  }
`;

export const PriceValue = styled.span`
  font-weight: 600;
  color: #262626;
  font-size: 12px;
`;

export const TotalPrice = styled.span`
  font-weight: 700;
  color: #262626;
  font-size: 14px;
`;

export const RemoveButton = styled(Button)`
  background: #ffffff;
  border: 1px solid #f5222d;
  color: #f5222d;
  height: 32px;
  font-size: 14px;

  svg {
    color: #f5222d;
  }

  &:hover,
  &:focus {
    background: #ffffff;
    border-color: #f5222d;
    color: #f5222d;
    opacity: 0.8;
  }
`;

export const FreightInfo = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: #fff9eb;
  padding: 2px;
  border-radius: 1px;
  color: #f78e1e;
  font-weight: 700;
  width: fit-content;
  font-size: 10px;
`;

export const ExpandedSection = styled.div``;

export const ExpandedTitle = styled.h4`
  color: #f78e1e;
  font-size: 10px;
  font-weight: 400;
  margin: 0;
  text-transform: uppercase;
`;

export const DashedDivider = styled.hr`
  width: 100%;
  height: 1px;
  background: none;
  border: none;
  border-top: 1px dashed #f0f0f0;
  margin: 12px 0;
`;
